import React from 'react';
import { Button } from 'antd';
import { MonitorOutlined, CodeOutlined } from '@ant-design/icons';
import { EmailPreviewModalProps } from '../types.d';
import { TEMPLATE_TABLE_CONSTANTS } from '../constants';
import { StyledModal, StyledTabs, PreviewContent, CodeBlock } from '../styles';

const EmailPreviewModal: React.FC<EmailPreviewModalProps> = ({ isOpen, onClose, template }) => {
  if (!template) return null;

  const tabItems = [
    {
      key: 'preview',
      label: (
        <>
          <MonitorOutlined style={{ marginRight: 8 }} />
          {TEMPLATE_TABLE_CONSTANTS.MODAL_TITLES.PREVIEW}
        </>
      ),
      children: (
        <PreviewContent>
          <iframe
            srcDoc={template.htmlContent || `<p>${TEMPLATE_TABLE_CONSTANTS.MESSAGES.NO_CONTENT}</p>`}
            title={`Preview of ${template.name}`}
          />
        </PreviewContent>
      ),
    },
    {
      key: 'source',
      label: (
        <>
          <CodeOutlined style={{ marginRight: 8 }} />
          {TEMPLATE_TABLE_CONSTANTS.MODAL_TITLES.HTML_SOURCE}
        </>
      ),
      children: (
        <CodeBlock>{template.htmlContent || TEMPLATE_TABLE_CONSTANTS.MESSAGES.NO_HTML_CONTENT}</CodeBlock>
      ),
    },
  ];

  return (
    <StyledModal
      title={
        <div>
          <div style={{ marginBottom: 4 }}>{template.name}</div>
          <div
            style={{
              fontSize: 13,
              color: 'var(--text-secondary)',
              fontWeight: 400,
            }}
          >
            {template.subject || 'No subject'}
          </div>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      width="90%"
      style={{ maxWidth: '900px' }}
      footer={[
        <Button key="close" onClick={onClose}>
          {TEMPLATE_TABLE_CONSTANTS.BUTTONS.CLOSE}
        </Button>,
        <Button key="edit" type="primary" onClick={onClose}>
          {TEMPLATE_TABLE_CONSTANTS.BUTTONS.EDIT_TEMPLATE}
        </Button>,
      ]}
    >
      <StyledTabs items={tabItems} />
    </StyledModal>
  );
};

export default EmailPreviewModal;
